import Moon1 from "./Moon1";
//import Moon2 from "./Moon2";

function App() {
  return <Moon1 />;
}

export default App;
